import { ConversationContextActions } from "./actions";
import { ConversationContextIntelligence } from "./intelligence";

export function ConversationContext({ personId }: { personId: number }) {
	return (
		<div data-component="conversation-context" className="flex min-w-0 flex-1 flex-col">
			<ConversationContextActions personId={personId} />
			<ConversationContextIntelligence personId={personId} />
		</div>
	);
}
